import Modal from '../../../Modal/modal'

export default Modal